"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ResponsiveLayout_1 = __importDefault(require("../ResponsiveLayout"));
const DesktopNav_1 = __importDefault(require("./DesktopNav"));
const MobileNav_1 = __importDefault(require("./MobileNav"));
const react_hooks_1 = require("@uifabric/react-hooks");
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const AuthProvider_1 = require("../AuthProvider");
const hookrouter_1 = require("hookrouter");
const NavBar = () => {
    var _a;
    const auth = AuthProvider_1.useAuth();
    const [profileInfo, setProfileInfo] = react_1.default.useState();
    const [isHelpOpen, setIsHelpOpen] = react_1.default.useState(false);
    const [isUserInfoOpen, setIsUserInfoOpen] = react_1.default.useState(false);
    const openHelpPanel = react_hooks_1.useConstCallback(() => setIsHelpOpen(true));
    const dismissHelpPanel = react_hooks_1.useConstCallback(() => setIsHelpOpen(false));
    const openUserInfoPanel = react_hooks_1.useConstCallback(() => setIsUserInfoOpen(true));
    const dismissUserInfoPanel = react_hooks_1.useConstCallback(() => setIsUserInfoOpen(false));
    react_1.default.useEffect(() => {
        if (auth.isAuthenticated) {
            auth.getProfile().then((profileInfo) => {
                setProfileInfo(profileInfo);
            }).catch((e) => {
                // TODO: Show a message when the profile load fails
                console.log('Failed to load profile info', e);
            });
        }
    }, [auth.isAuthenticated]);
    const persona = {
        imageUrl: (_a = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.avatarUrl) !== null && _a !== void 0 ? _a : undefined,
        imageInitials: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.initals,
        text: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.fullName,
        secondaryText: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.position,
        imageAlt: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.fullName
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ResponsiveLayout_1.default, { breakPoint: 640, renderDesktop: () => (react_1.default.createElement(DesktopNav_1.default, { personaInfo: persona, openHelpPanel: openHelpPanel, openUserInfoPanel: openUserInfoPanel })), renderMobile: () => (react_1.default.createElement(MobileNav_1.default, { personaInfo: persona, openHelpPanel: openHelpPanel, openUserInfoPanel: openUserInfoPanel })) }),
        react_1.default.createElement(office_ui_fabric_react_1.Panel, { headerText: "Help", isOpen: isHelpOpen, onDismiss: dismissHelpPanel, closeButtonAriaLabel: "Close", isLightDismiss: true },
            react_1.default.createElement("p", null, "Visit the service desk portal to create or track a support ticket and search documentation."),
            react_1.default.createElement("p", null,
                react_1.default.createElement(office_ui_fabric_react_1.Link, { href: "https://jira.gotosage.com/servicedesk/customer/portal/", target: "_blank" }, "Service Desk Portal"))),
        react_1.default.createElement(office_ui_fabric_react_1.Panel, { headerText: "My Account", isOpen: isUserInfoOpen, onDismiss: dismissUserInfoPanel, closeButtonAriaLabel: "Close", isLightDismiss: true },
            react_1.default.createElement(office_ui_fabric_react_1.Persona, Object.assign({}, persona, { size: office_ui_fabric_react_1.PersonaSize.size72, onRenderTertiaryText: () => react_1.default.createElement("div", null,
                    react_1.default.createElement(office_ui_fabric_react_1.Link, { onClick: () => { hookrouter_1.navigate('/logout'); setIsUserInfoOpen(false); } }, "Sign out")), styles: { root: { marginTop: '20px' } } })))));
};
exports.default = NavBar;
